import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".ButtonGroup_root__DGOTX{display:flex}.ButtonGroup_root__DGOTX>button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;margin-left:-1px}.ButtonGroup_root__DGOTX>button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}";
var S = {"root":"ButtonGroup_root__DGOTX"};
styleInject(css_248z);

export { S as default };
